module.exports = __webpack_public_path__ + "nc_static/media/device-button.6859c735.svg";